<template>
    <b-modal
        v-model="shown"
        centered
        title="Hide or show columns/rows"
        lazy
    >
        <div
            v-for="column in columns"
            :key="column.name"
            class="checkbox"
        >
            <label>
                <input
                    v-model="displayed"
                    type="checkbox"
                    :value="column.name"
                > {{ $t(column.heading || column.name) }}
            </label>
        </div>
        <div slot="modal-footer">
            <b-btn
                variant="default"
                class="mr-2"
                @click="handleClose"
            >
                Close
            </b-btn>
            <Button
                variant="success"
                :disabled="loading"
                :loading="submitLoading"
                @click="handleSubmit"
            >
                Save
            </Button>
        </div>
    </b-modal>
</template>

<script>
export default {
    data() {
        return {
            shown: false,
            loading: false,
            submitLoading: false,
        };
    },

    computed: {
        columns() {
            return this.$store.getters['costable/columns'].filter(column => column.heading);
        },
        displayed: {
            get() {
                return this.columns
                    .filter(column => !this.hiddenColumns.includes(column.name))
                    .map(column => column.name);
            },
            set(value) {
                const hiddenColumns = this.columns
                    .filter(column => !value.includes(column.name))
                    .map(column => column.name);

                this.$store.dispatch('costable/setHiddenColumns', hiddenColumns);
            },
        },
        hiddenColumns() {
            return this.$store.getters['costable/hiddenColumns'];
        },
    },

    created() {
        this.$eventBus.$on(this.$events.openColumnSettingsModel, () => {
            this.shown = true;
        });
    },

    methods: {
        async handleSubmit() {
            this.submitLoading = true;
            try {
                await this.$store.dispatch('costable/saveColumnSettings');
                this.handleClose();
            } finally {
                this.submitLoading = false;
            }
        },
        handleClose() {
            this.shown = false;
        },
    },
};
</script>
